module.exports = __webpack_public_path__ + "static/06-d4ab2a1e802ea219b315eee3c5df9471.png";